import React, { useCallback, useEffect, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import EventView from "../../pages/calendar/EventView";
import { useNavigate } from "react-router-dom";
import Loader from "../loader/Loader";
import axiosInstance from "../../utils/axiosConfig";

const MyCalendar = () => {
  const [events, setEvents] = useState([]);
  const [selectedTip, setSelectedTip] = useState(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  // const handleDateClick = (info) => {
  //   const today = new Date();
  //   today.setHours(0, 0, 0, 0);

  //   navigate(`/tips/add`, { state: { selectedDate: info.dateStr } });
  // };
    const handleDateClick = (info) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const selectedDate = new Date(info.dateStr);
    selectedDate.setHours(0, 0, 0, 0);
    // Prevent selecting previous dates
    if (selectedDate < today) {
      return;
    }
    navigate(`/tips/add`, { state: { selectedDate: info.dateStr } });
  };

  const fetchTips = useCallback(async (month = null, year = null) => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/calendar/tips/list`,
        {
          params: {
            month,
            year,
          },
        }
      );
      if (response.data.success) {        
        const calendarEvents = response.data.data.map((tip) => ({
          title: tip.title,
          date: new Date(tip.date).toISOString().split("T")[0],
          extendedProps: {
            content: tip.content,
            favoriteCount: tip.favoriteCount,
          },
        }));
        setEvents(calendarEvents);
      } else {
        setEvents([]);
      }
    } catch (error) {
      console.error("Error fetching tips:", error);
      setEvents([]);
    } finally {
      setLoading(false);
    }
  }, []);

  const handleEventClick = (info) => {
    const event = info.event;
    setSelectedTip({
      title: event.title,
      content: event.extendedProps.content,
      date: event.start,
      favoriteCount: event.extendedProps.favoriteCount,
    });
  };

  //   useEffect(() => {
  //     fetchTips();
  //   }, [fetchTips]);

  const handleDatesSet = (dateInfo) => {    
    // Get the month from the start date of the visible range
    const currentMonth = dateInfo.view.currentStart.getMonth() + 1; // +1 because getMonth() returns 0-11
    const fullYear = dateInfo.view.currentStart.getFullYear();
    fetchTips(currentMonth, fullYear);
  };

  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
    setSelectedTip(null);
  };
  const handleShow = () => setShow(true);
  return (
    <div className="calendar-container">
      {loading && <Loader />}
      <FullCalendar
        defaultView="dayGridMonth"
        header={{
          left: "prev,next",
          center: "title",
          right: "dayGridMonth,timeGridWeek,timeGridDay",
        }}
        themeSystem="Simplex"
        plugins={[dayGridPlugin, interactionPlugin]}
        events={events}
        eventClick={handleEventClick}
        dateClick={handleDateClick}
        datesSet={handleDatesSet}
        
      />
      {selectedTip && (
        <EventView
          show={show}
          handleClose={handleClose}
          handleShow={handleShow}
          setShow={setShow}
          tip={selectedTip}
        />
      )}
    </div>
  );
};

export default MyCalendar;
